/* src/app/layout/components/account-menu/account-menu.component.scss */
.account-menu {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  background: #197c82;
  padding: 15px 20px !important;
  width: 100%;
  color: var(--white);
  display: flex;
}
.account-menu .username {
  font-weight: 600;
  color: var(--white);
}
/*# sourceMappingURL=data:application/json;base64,ewogICJ2ZXJzaW9uIjogMywKICAic291cmNlcyI6IFsic3JjL2FwcC9sYXlvdXQvY29tcG9uZW50cy9hY2NvdW50LW1lbnUvYWNjb3VudC1tZW51LmNvbXBvbmVudC5zY3NzIl0sCiAgInNvdXJjZXNDb250ZW50IjogWyIuYWNjb3VudC1tZW51e1xuICAgIGJvcmRlci10b3A6IDFweCBzb2xpZCByZ2JhKDI1NSwyNTUsIDI1NSwwLjEpO1xuICAgIGJhY2tncm91bmQ6ICMxOTdjODI7XG4gICAgcGFkZGluZzogMTVweCAyMHB4ICFpbXBvcnRhbnQ7XG4gICAgd2lkdGg6IDEwMCU7XG4gICAgY29sb3I6IHZhcigtLXdoaXRlKTtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIC51c2VybmFtZXtcbiAgICAgICAgZm9udC13ZWlnaHQ6IDYwMDtcbiAgICAgICAgY29sb3I6IHZhcigtLXdoaXRlKTtcbiAgICB9XG59Il0sCiAgIm1hcHBpbmdzIjogIjtBQUFBLENBQUE7QUFDSSxjQUFBLElBQUEsTUFBQSxLQUFBLEdBQUEsRUFBQSxHQUFBLEVBQUEsR0FBQSxFQUFBO0FBQ0EsY0FBQTtBQUNBLFdBQUEsS0FBQTtBQUNBLFNBQUE7QUFDQSxTQUFBLElBQUE7QUFDQSxXQUFBOztBQUNBLENBUEosYUFPSSxDQUFBO0FBQ0ksZUFBQTtBQUNBLFNBQUEsSUFBQTs7IiwKICAibmFtZXMiOiBbXQp9Cg== */
